import { camelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import useSWR from "swr"
import { useSmoothApi } from "./useSmoothApi"
import { User } from "./useUserSWR"

type GetUsersParams = {
  page?: number
  searchParams?: string
  limit?: number
  enabled?: boolean
}

export const useUsersListSWR = (params: GetUsersParams = {}) => {
  const { getWithToken } = useSmoothApi()
  const { searchParams = "", limit = 100, enabled = true } = params

  // URLを生成する関数
  const generateUrl = () => {
    if (searchParams) {
      return `${SMOOTH_SMOOTHER_API_URL}/users?search_params=${encodeURIComponent(searchParams)}&limit=${limit}`
    }

    return `${SMOOTH_SMOOTHER_API_URL}/users?limit=${limit}`
  }

  // ユーザーリストを取得
  const url = generateUrl()
  const usersSWR = useSWR<User[]>(
    enabled ? url : null,
    async (url) => {
      const res = await getWithToken(url)
      const data = res.data?.data || []
      return data.map((d: any) => camelCase(d)) as User[]
    },
    {
      // 検索パラメータが変わった時は再取得
      revalidateOnFocus: false,
    }
  )

  return {
    users: usersSWR.data || [],
    isLoading: enabled && !usersSWR.data && !usersSWR.error,
    error: usersSWR.error,
    mutate: usersSWR.mutate,
  }
}
